import React, { useState } from "react";
import "../../styles/components/ContactCta.css";

import arrowCircle from "../../img/hero/arrow-circle.png"; // круг зі стрілкою
import ctaArtRight from "../../img/hero/cta-right-2.webp";    // правий арт

import Modal from "../../components/Modal";             // ✅ модалка
import ContactFormSimple from "../../components/ContactFormSimple"; // ✅ форма

export default function ContactCta() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="cta cta-anim" aria-label="CTA">
      {/* Правий арт поверх синього фону */}
      <img src={ctaArtRight} alt="" aria-hidden="true" className="cta__art cta-anim__art" />

      {/* Контент над артом */}
      <div className="cta__content">
        {/* Скляна плашка + заголовок */}
        <h2 className="cta__title cta-anim__title">
          Ready to make your product{" "}
<br />
personal? <span>Let’s talk!</span>
        </h2>

        {/* Кнопка */}
        <button
  className="cta__btn Secondary cta-anim__btn"
          type="button"
          onClick={() => setOpenModal(true)}
        >
          <span className="Secondary__text">Contact Us</span>
          <img className="Secondary__circle" src={arrowCircle} alt="" />
        </button>
      </div>

      {/* Модалка */}
      <Modal open={openModal} onClose={() => setOpenModal(false)} title="Contact us">
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
